<script>
  import { Line, mixins } from 'vue-chartjs'
  import numeral from 'numeral'
  import moment from 'moment'

  export default {
    extends: Line,
    props: {
      axeTypeY: {
        type: String,
        required: false,
        default: 'number'
      },
      numberLabel: {
        type: String,
        required: false,
        default: ''
      },
      numberRounded: {
        type: Boolean,
        required: false,
        default: false
      },
      currency: {
        type: String,
        required: false,
        default: ''
      },
      axeTypeX: {
        type: String,
        required: false,
        default: 'date'
      },
      backgroundColor: {
        type: String,
        required: false,
        default: 'rgba(63, 81, 181, 0.1)'
      },
      borderColor: {
        type: String,
        required: false,
        default: '#2466CB'
      },
      showAxeX: {
        type: Boolean,
        required: false,
        default: true
      },
      showAxeY: {
        type: Boolean,
        required: false,
        default: true
      },
      showGridLinesAxeY: {
        type: Boolean,
        required: false,
        default: true
      },
      showPoint: {
        type: Boolean,
        required: false,
        default: false
      },
      borderWidth: {
        type: Number,
        required: false,
        default: 2
      },
      showLegend: {
        type: Boolean,
        required: false,
        default: false
      },
      monthLabel: {
        type: String,
        required: false,
        default: ''
      },
      xAxisType: {
        type: String,
        required: false,
        default: 'date'
      }
    },
    mixins: [
      mixins.reactiveProp
    ],
    data () {
      return {
        gradient: null
      }
    },
    mounted () {
      const ctx = this.$refs.canvas.getContext('2d')
      const gradient = ctx.createLinearGradient(0, 0, 0, 400)
      gradient.addColorStop(0, 'rgba(0, 84, 212, 0.25)')
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0)')
      this.gradient = gradient
      this.drawChart()
    },
    watch: {
      chartData () {
        this.drawChart()
      }
    },
    computed: {
      options () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: this.showLegend,
            position: 'top',
            align: 'end',
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              padding: 20,
              fontColor: '#63627C'
            }
          },
          hover: {
            mode: 'index',
            intersect: false
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: '#FFFFFF',
            titleFontColor: '#63627C',
            titleFontSize: 11,
            bodyFontColor: '#63627C',
            callbacks: {
              title: (tooltipItems, data) => {
                const date = tooltipItems[0].xLabel
                if (this.xAxisType === 'date' && moment(date, 'YYYY-MM-DD', true).isValid()) {
                  return moment(date).format('DD MMMM YYYY')
                }
                return null
              },
              label: (item, data) => {
                let label = data.datasets[item.datasetIndex].label || ''
                let value = item.yLabel
                if (this.currency) {
                  return `${label}: ${this.$fmt.currency(this.currency, value)}`
                }
                if (this.axeTypeY === 'number') {
                  value = this.numberRounded ? this.$fmt.decimal(value, 2) : this.$fmt.integer(value)
                }
                if (this.numberLabel) {
                  value = `${this.numberLabel} ${value}`
                }
                return `${label}: ${value}`
              }
            }
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: '#CFD8DC',
                display: this.showGridLinesAxeY,
                drawBorder: false
              },
              ticks: {
                suggestedMin: 0,
                display: this.showAxeY,
                fontColor: this.$vuetify.theme.dark ? '#E6E9F0' : '#8B94A9',
                fontSize: 11,
                maxTicksLimit: 6,
                padding: 10,
                callback: (value) => {
                  return numeral(value).format('0.0a').toUpperCase().replace('.0', '')
                }
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: !!this.monthLabel,
                labelString: this.monthLabel,
                fontColor: '#63627C',
                fontSize: 11,
                fontStyle: 'bold'
              },
              gridLines: {
                display: false
              },
              ticks: {
                display: this.showAxeX,
                fontColor: this.$vuetify.theme.dark ? '#E6E9F0' : '#8B94A9',
                fontSize: 11,
                // padding: 20,
                callback: (value, index, values) => {
                  if (this.xAxisType === 'date') {
                    return moment(value).format('DD')
                  }
                  return value
                }
              }
            }]
          }
        }
      }
    },
    methods: {
      drawDatasets () {
        if (this.chartData && this.chartData.datasets) {
          this.chartData.datasets.forEach((dataset) => {
            dataset.borderColor = this.borderColor
            dataset.backgroundColor = this.gradient
            dataset.borderWidth = this.borderWidth
            dataset.pointBackgroundColor = this.borderColor
            dataset.pointHoverRadius = 5
            dataset.pointRadius = this.showPoint ? 3 : 0
            dataset.lineTension = 0.4
            dataset.fill = true
          })
        }
      },
      drawChart () {
        this.drawDatasets()
        this.renderChart(this.chartData, this.options)
      }
    }
  }
</script>